<template>
  <div class="docs">
    <br />
    <br />
    <div class="cont">
      <h1 class="text-left text-dark text">
        Getting Started using <strong>GraphQL API</strong>
      </h1>
      <!--- GRAPHQL SCCHEMA DOCS -->
      <!--- GRAPHQL SCCHEMA DOCS -->
      <h3 class="text-left text-dark mt-4 mb-2 text">GraphQL schema</h3>
      <p class="text-left description">
      </p>
      <p class="text-left">see <a href="https://projectgigs.herokuapp.com/graphql">graphql dev tool</a></p>

      <div>
        <pre class="float-left text-left code code-schema">
						<code class="language-javascript">
	query {
	  project(user_email : "mouadtaoussi0@gmail.com" ) {
	    _id
	    user_email
	    title
	    description
	    skills
	    budget
	    created_at
	    proposals {
	      _id
	      project_id
	      user_email
	      description
	      budget
	      created_at
	      
	    }
	  }
	  projects(limit:10) {
	     _id
	    user_email
	    title
	    description
	    skills
	    budget
	    created_at
	    proposals {
	      _id
	      project_id
	      user_email
	      description
	      budget
	      created_at
	      
	    }
	  }
	  user (email : "mouadtaoussi0@gmail.com"){
	    _id
	    name
	    email
	    phone
	    address
	    zipCode
	    city
	    country
	    skills
	    created_at
	  }
	  users(limit:10) {
	    _id
	    name
	    email
	    phone
	    address
	    zipCode
	    city
	    country
	    skills
	    created_at
	  }
	  
	}
						</code>
					</pre>
      </div>
      <div class="space"></div>
      <!-- CURL DOCS -->
      <!-- CURL DOCS -->
      <h3
        style="margin-top:40px!importtant;margin-bottom:20px!importtant;"
        class="text-left text-dark mt-4 mb-2 text"
      >
        With Curl
      </h3>
      <p class="text-left description">
      </p>
      <div>
        <pre class="float-left text-left code code-curl">
						<code class="language-bash">
	curl \
	  -X POST \
	  -H "Content-Type: application/json" \
	  --data '{ "query": "{ projects(limit:5) { _id title budget } }" }' \
	  https://projectgigs.herokuapp.com/graphql
						</code>
					</pre>
      </div>
      <div class="space"></div>
      <!-- AXIOS DOCS-->
      <!-- AXIOS DOCS-->
      <h3
        style="margin-top:40px!importtant;margin-bottom:20px!importtant;"
        class="text-left text-dark mt-4 mb-2 text"
      >
        With Axios
      </h3>
      <p class="text-left description">
      </p>

      <div>
        <pre class="float-left text-left code code-apollo">
						<code class="language-javascript">
	const axios = require("axios")axios({

	axios({
	  url: 'https://projectgigs.herokuapp.com/graphql',
	  method: 'post',
	  data: JSON.stringify({ query: '{ projects(limit:5) { _id title budget } }' })
	})  
	.then((result) => {
	  console.log(result.data)
	})
	.catch((err) => {
	  console.log(err)
	});

						</code>
					</pre>
      </div>
      <div class="space"></div>
      <!-- FETCH DOCS-->
      <!-- FETCH DOCS-->
      <h3
        style="margin-top:40px!importtant;margin-bottom:20px!importtant;"
        class="text-left text-dark mt-4 mb-2 text"
      >
        With Fetch
      </h3>
      <p class="text-left description">
      </p>
      <div>
        <pre class="float-left text-left code code-fetch">
						<code class="language-javascript">
	fetch('https://projectgigs.herokuapp.com/graphql', {
	  method: 'POST',
	  headers: { 'Content-Type': 'application/json' },
	  body: JSON.stringify({ query: '{ projects(limit:5) { _id title budget } }' }),
	})
	  .then(res => res.json())
	  .then(res => console.log(res.data));
						</code>
					</pre>
      </div>
      <div class="space"></div>
      <!---    APOLLO DOCS    -->
      <!---    APOLLO DOCS    -->
      <h3
        style="margin-top:40px!importtant;margin-bottom:20px!importtant;"
        class="text-left text-dark mt-4 mb-2 text"
      >
        With Apollo
      </h3>
    </div>
    <!---->
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
import footerApp from ".././components/footer.vue";

export default {
  name: "docs",
  components: {
    footerApp
  },
  data: () => {
    return {
      msg: "Hello World!"
    };
  },
  created() {

    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>

<style scoped>
.text {
  color: rgba(0, 0, 0, 0.95);
}
/*.docs {
		margin-top: 50px;
	}*/
.code {
  width: 100%;
  height: 300px;
  overflow: auto;
}
.code-curl {
  height: 200px !important;
}
.code-fetch {
  height: 250px !important;
}

.description {
  font-weight: 100;
}
.cont {
  width: 70% !important;
  margin: 0 auto;
}
.space {
  height: 100px;
}
@media only screen and (max-width: 600px) {
  .cont {
    width: 95% !important;
    margin: 0 auto;
  }
}
</style>
